import React from 'react';
import { Icon } from '@/components/ui';
import { CLIENT_MOBILE_TABS } from './clientNav';

interface ClientMobileTabBarProps {
  activeTabId: string | null;
  moreOpen: boolean;
  moreActive: boolean;
  /** Unread counts keyed by tab id, e.g. { messages, notifications }. */
  counts: Record<string, number>;
  onNavigate: (path: string) => void;
  onToggleMore: () => void;
}

export const ClientMobileTabBar = ({
  activeTabId,
  moreOpen,
  moreActive,
  counts,
  onNavigate,
  onToggleMore,
}: ClientMobileTabBarProps) => (
  <nav
    className="tw-flex-none tw-h-[64px] tw-flex tw-items-stretch tw-bg-white tw-border-t tw-border-ds-hairline tw-relative tw-z-30"
    style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
  >
    {CLIENT_MOBILE_TABS.map((it) => {
      const isMore = it.id === 'more';
      const on = isMore
        ? moreOpen || moreActive
        : activeTabId === it.id && !moreOpen;
      const count = counts[it.id] || 0;
      return (
        <button
          key={it.id}
          onClick={() => (isMore ? onToggleMore() : onNavigate(it.path))}
          className={`tw-flex-1 tw-border-0 tw-bg-transparent tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[3px] tw-cursor-pointer tw-font-poppins tw-py-[8px] tw-px-[2px] ${
            on ? 'tw-text-ds-primary' : 'tw-text-ds-ink-mute'
          }`}
        >
          <span className="tw-relative tw-inline-flex">
            <Icon
              name={it.icon}
              size={22}
              color={on ? 'var(--twilight-sky)' : 'var(--ink-mute)'}
            />
            {count > 0 && (
              <span className="tw-absolute -tw-top-[5px] -tw-right-[8px] tw-min-w-[15px] tw-h-[15px] tw-px-[4px] tw-rounded-full tw-bg-ds-danger tw-text-white tw-text-[9px] tw-font-semibold tw-inline-flex tw-items-center tw-justify-center tw-border-[1.5px] tw-border-solid tw-border-white tw-box-border">
                {count > 9 ? '9+' : count}
              </span>
            )}
          </span>
          <span
            className={`tw-text-[10px] tw-leading-none ${on ? 'tw-font-semibold' : 'tw-font-medium'}`}
          >
            {it.label}
          </span>
        </button>
      );
    })}
  </nav>
);
